import './wishlist.css';

export default () => {
  class MainWishlist extends HTMLElement {
    constructor() {
      super();
      this.wishlistGrid = null;
      this.initialOrder = [];
      this.sortSelect = this.querySelector('#sortSelect');
      this.observer = new MutationObserver(this.handleMutations.bind(this));
    }

    connectedCallback() {
      this.initElements();
      this.initEventListeners();
      this.observeDomChanges();
    }

    initElements() {
      this.wishlistGrid = document.querySelector('.swym-wishlist-grid');

      if (this.wishlistGrid) {
        this.initialOrder = Array.from(this.wishlistGrid.children);
      } else {
        // eslint-disable-next-line
        console.warn('Wishlist grid element not found.');
      }
    }

    initEventListeners() {
      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', (event) => {
          this.reorderBlocks(event.target.value);
        });
      }
    }

    observeDomChanges() {
      this.observer.observe(document.body, { childList: true, subtree: true });
    }

    handleMutations(mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          if (!this.wishlistGrid) {
            this.initElements();
            if (this.wishlistGrid) {
              // If the wishlist grid is found after mutation, reinitialize the order
              this.initialOrder = Array.from(this.wishlistGrid.children);
            }
          }
        }
      }
    }

    reorderBlocks(selectedValue) {
      if (!this.wishlistGrid) {
        return;
      }

      const wishlistItems = Array.from(this.wishlistGrid.children);

      switch (selectedValue) {
        case 'date':
          this.initialOrder.forEach(item => this.wishlistGrid.appendChild(item));
          break;
        case 'lowToHigh':
          wishlistItems.sort((a, b) => {
            const priceA = parseFloat(a.querySelector('.swym-product-final-price').textContent.replace(/[^\d.]/g, ''));
            const priceB = parseFloat(b.querySelector('.swym-product-final-price').textContent.replace(/[^\d.]/g, ''));
            return priceA - priceB;
          });
          wishlistItems.forEach(item => this.wishlistGrid.appendChild(item));
          break;
        case 'highToLow':
          wishlistItems.sort((a, b) => {
            const priceA = parseFloat(a.querySelector('.swym-product-final-price').textContent.replace(/[^\d.]/g, ''));
            const priceB = parseFloat(b.querySelector('.swym-product-final-price').textContent.replace(/[^\d.]/g, ''));
            return priceB - priceA;
          });
          wishlistItems.forEach(item => this.wishlistGrid.appendChild(item));
          break;
        default:
          break;
      }
    }

    disconnectedCallback() {
      if (this.sortSelect) {
        this.sortSelect.removeEventListener('change', this.reorderBlocks);
      }
      this.observer.disconnect();
    }
  }

  const init = () => {
    if (!customElements.get('main-wishlist')) {
      customElements.define('main-wishlist', MainWishlist);
    }
  };
  init();
};
